exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-preview-card{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:81px;border-radius:5px;overflow:hidden}.list-preview-card .preview-image-container{width:86px;position:relative;height:100%}.list-preview-card .preview-image{-o-object-fit:cover;object-fit:cover;position:absolute;top:0;bottom:0;left:0;right:0;width:100%;height:100%}.list-preview-card .list-preview-body{padding:8px}.list-preview-card.layout-card .preview-image-container{width:100%;height:100px}.list-preview-card.layout-card .preview-image{-o-object-fit:contain;object-fit:contain;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e23a78d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/lists/listPreviewCard.vue
// module id = J0di
// module chunks = 1 6 8 12 14 15 38 70